/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LineupEditorPlayerSelectQueryVariables = {|
  slateID: string,
  rosterSlotID: string,
  salaryMax: number,
|};
export type LineupEditorPlayerSelectQueryResponse = {|
  +playersForSlate: ?$ReadOnlyArray<?{|
    +id: string,
    +player: {|
      +id: string,
      +name: string,
      +shortenedName: ?string,
      +team: ?{|
        +abbreviation: string,
        +name: ?string,
      |},
    |},
    +position: ?string,
    +fppg: any,
    +salary: number,
    +rosterSlots: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +name: string
        |}
      |}>
    |},
    +slateCompetition: ?{|
      +prettyStartTime: ?string
    |},
    +gupPercProj: ?any,
  |}>
|};
export type LineupEditorPlayerSelectQuery = {|
  variables: LineupEditorPlayerSelectQueryVariables,
  response: LineupEditorPlayerSelectQueryResponse,
|};
*/


/*
query LineupEditorPlayerSelectQuery(
  $slateID: ID!
  $rosterSlotID: ID!
  $salaryMax: Int!
) {
  playersForSlate(slateId: $slateID, rosterSlotId: $rosterSlotID, salaryMax: $salaryMax) {
    id
    player {
      id
      name
      shortenedName
      team {
        abbreviation
        name
        id
      }
    }
    position
    fppg
    salary
    rosterSlots {
      edges {
        node {
          name
          id
        }
      }
    }
    slateCompetition {
      prettyStartTime
      id
    }
    gupPercProj
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rosterSlotID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "salaryMax"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slateID"
},
v3 = [
  {
    "kind": "Variable",
    "name": "rosterSlotId",
    "variableName": "rosterSlotID"
  },
  {
    "kind": "Variable",
    "name": "salaryMax",
    "variableName": "salaryMax"
  },
  {
    "kind": "Variable",
    "name": "slateId",
    "variableName": "slateID"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortenedName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fppg",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gupPercProj",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LineupEditorPlayerSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterSlotTypeConnection",
            "kind": "LinkedField",
            "name": "rosterSlots",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionType",
            "kind": "LinkedField",
            "name": "slateCompetition",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "LineupEditorPlayerSelectQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v5/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterSlotTypeConnection",
            "kind": "LinkedField",
            "name": "rosterSlots",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionType",
            "kind": "LinkedField",
            "name": "slateCompetition",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51d965e396536cfe237bdd37c910ed97",
    "id": null,
    "metadata": {},
    "name": "LineupEditorPlayerSelectQuery",
    "operationKind": "query",
    "text": "query LineupEditorPlayerSelectQuery(\n  $slateID: ID!\n  $rosterSlotID: ID!\n  $salaryMax: Int!\n) {\n  playersForSlate(slateId: $slateID, rosterSlotId: $rosterSlotID, salaryMax: $salaryMax) {\n    id\n    player {\n      id\n      name\n      shortenedName\n      team {\n        abbreviation\n        name\n        id\n      }\n    }\n    position\n    fppg\n    salary\n    rosterSlots {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n    slateCompetition {\n      prettyStartTime\n      id\n    }\n    gupPercProj\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '882da5b89cf818298e9b3b03a1201c42';

module.exports = node;
